module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_3009.b47b661e.png";